import deleteApiKey from "@/store/ai-workspace/communication-channel/actions/deleteApiKey";
import generateApiKey from "@/store/ai-workspace/communication-channel/actions/generateApiKey";
import getApiKeys from "@/store/ai-workspace/communication-channel/actions/getApiKeys";
import updateOrCreateTwilio from "@/store/ai-workspace/communication-channel/actions/updateOrCreateTwilio";
import getTwilioChannelInfo from "@/store/ai-workspace/communication-channel/actions/getTwilioChannelInfo";
import getIncomingEventChannelInfo
  from '@/store/ai-workspace/communication-channel/actions/getIncomingEventChannelInfo';
import updateOrCreateIncomingEvent
  from '@/store/ai-workspace/communication-channel/actions/updateOrCreateIncomingEventChannel';
import getPodiumChannelInfo from '@/store/ai-workspace/communication-channel/actions/getPodiumChannelInfo';
import updateOrCreatePodium from '@/store/ai-workspace/communication-channel/actions/updateOrCreatePodiumChannel';

const actions = {
    deleteApiKey,
    generateApiKey,
    getApiKeys,
    updateOrCreateTwilio,
    getTwilioChannelInfo,
    getIncomingEventChannelInfo,
    updateOrCreateIncomingEvent,
    getPodiumChannelInfo,
    updateOrCreatePodium
}

export default actions;